import { IAxiosInstance } from "../../../AbstractApiClient/AbstractApiClient";
import { IApiResponse } from "../../../AbstractApiClient/IApiResponse";
import {
  TGetPushToCardCardsRequestSchema,
  TGetPushToCardCardsResponseSchema,
} from "./getPushToCardCards.schema";

export const getPushToCardCards =
  (axios: IAxiosInstance) =>
  async (params: TGetPushToCardCardsRequestSchema) => {
    const response = await axios.noRetry.get<
      IApiResponse<TGetPushToCardCardsResponseSchema>
    >(`/api/push-to-card/cards`, { params });
    return response.data;
  };
